// extracted by mini-css-extract-plugin
export default {"contactDetailsDiv":"ContactDetails_contactDetailsDiv__Cga4a","details":"ContactDetails_details__5a+E8"};